import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class CoffeeBadge extends WritingBadge {
  public readonly id = BadgeId.coffee;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.streakInfo.longest >= 10 || stats.streakInfo.current >= 10;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/coffee.ts